// =============================================
// SEAFOODSSHOW SHOPIFY THEME JS
// =============================================

window.ShopifyCart = {
  openDrawer() {
    document.querySelector('.cart-overlay')?.classList.add('open');
    document.querySelector('.cart-drawer')?.classList.add('open');
    document.body.style.overflow = 'hidden';
  },

  closeDrawer() {
    document.querySelector('.cart-overlay')?.classList.remove('open');
    document.querySelector('.cart-drawer')?.classList.remove('open');
    document.body.style.overflow = '';
  },

  openSearch() {
    document.getElementById('search-modal')?.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => document.querySelector('.search-modal__input')?.focus(), 100);
  },

  closeSearch() {
    document.getElementById('search-modal')?.classList.remove('open');
    document.body.style.overflow = '';
  },

  toggleMobileMenu() {
    const menu = document.getElementById('mobile-menu');
    const backdrop = document.getElementById('mobile-backdrop');
    const btn = document.getElementById('hamburger-btn');
    const isOpen = menu?.classList.toggle('open');
    backdrop?.classList.toggle('open', isOpen);
    btn?.classList.toggle('open', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  },

  closeMobileMenu() {
    document.getElementById('mobile-menu')?.classList.remove('open');
    document.getElementById('mobile-backdrop')?.classList.remove('open');
    document.getElementById('hamburger-btn')?.classList.remove('open');
    document.body.style.overflow = '';
  },

  async add(variantId, quantity = 1) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });
      if (!res.ok) throw new Error('Add failed');
      await this.refresh();
      this.openDrawer();
    } catch (e) {
      console.error(e);
      alert('Could not add item to cart.');
    }
  },

  async addMultiple(items) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items.map(i => ({ id: i.id, quantity: i.quantity || 1 })) })
      });
      if (!res.ok) throw new Error('Add failed');
      await this.refresh();
      this.openDrawer();
    } catch (e) {
      console.error(e);
      alert('Could not add items to cart.');
    }
  },

  async changeQty(variantId, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: String(variantId), quantity })
      });
      if (!res.ok) throw new Error('Update failed');
      await this.refresh();
    } catch (e) {
      console.error(e);
    }
  },

  async refresh() {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    // Update count badge
    document.querySelectorAll('.nav__cart-badge, #cart-drawer-count').forEach(el => {
      if (el.id === 'cart-drawer-count') {
        el.textContent = `(${cart.item_count})`;
      } else {
        el.textContent = cart.item_count;
        el.classList.toggle('visible', cart.item_count > 0);
      }
    });

    // Update total
    const totalEl = document.getElementById('cart-drawer-total');
    if (totalEl) {
      const formatted = (cart.total_price / 100).toLocaleString('en', { minimumFractionDigits: 0 });
      totalEl.textContent = `${cart.currency} ${formatted}`;
    }

    // Render items
    const body = document.getElementById('cart-drawer-items');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-drawer__empty">
          <div class="cart-drawer__empty-icon">🛒</div>
          <div class="cart-drawer__empty-title">Your cart is empty</div>
          <div class="cart-drawer__empty-text">Add something delicious from our collections.</div>
        </div>`;
      return;
    }

    body.innerHTML = cart.items.map(item => {
      const priceFormatted = ((item.final_line_price / 100)).toLocaleString('en', { minimumFractionDigits: 0 });
      return `
        <div class="cart-item" data-variant-id="${item.variant_id}">
          <div class="cart-item__img">
            <img src="${item.image}" alt="${item.title}" loading="lazy">
          </div>
          <div class="cart-item__body">
            <div class="cart-item__title">${item.product_title}</div>
            <div class="cart-item__price">${cart.currency} ${priceFormatted}</div>
            <div class="cart-item__qty">
              <button class="cart-item__qty-btn" onclick="window.ShopifyCart.changeQty(${item.variant_id}, ${item.quantity - 1})">−</button>
              <span class="cart-item__qty-val">${item.quantity}</span>
              <button class="cart-item__qty-btn" onclick="window.ShopifyCart.changeQty(${item.variant_id}, ${item.quantity + 1})">+</button>
              <span class="cart-item__remove" onclick="window.ShopifyCart.changeQty(${item.variant_id}, 0)">Remove</span>
            </div>
          </div>
        </div>`;
    }).join('');
  }
};

window.addEventListener('scroll', () => {
  document.querySelector('.nav')?.classList.toggle('scrolled', window.scrollY > 10);
}, { passive: true });

document.addEventListener('keydown', e => {
  if (e.key === 'Escape') {
    window.ShopifyCart.closeDrawer();
    window.ShopifyCart.closeSearch();
    window.ShopifyCart.closeMobileMenu();
  }
});

window.ShopifyThemeProduct = {
  currentOptions: [],
  quantity: 1,

  init() {
    if (!window._currentProduct) return;
    this.currentOptions = (window._currentProduct.options || []).map((opt, idx) => {
      const activePill = document.querySelector(`.product-option-group[data-option-index="${idx}"] .product-option-pill.active`);
      return activePill ? activePill.getAttribute('data-option-value') : window._currentProduct.variants[0]?.options[idx];
    });
  },

  selectOption(optionIndex, value, buttonEl) {
    this.currentOptions[optionIndex] = value;

    const group = buttonEl.closest('.product-option-group');
    if (group) {
      group.querySelectorAll('.product-option-pill').forEach(btn => btn.classList.remove('active'));
      buttonEl.classList.add('active');
      const selectedValLabel = group.querySelector('.product-option-selected-val');
      if (selectedValLabel) selectedValLabel.textContent = value;
    }

    const matchedVariant = (window._currentProduct.variants || []).find(variant => {
      return variant.options.every((optVal, idx) => optVal === this.currentOptions[idx]);
    });

    if (matchedVariant) {
      window._currentVariant = matchedVariant;
      this.updateUI(matchedVariant);
    }
  },

  updateUI(variant) {
    const priceEl = document.getElementById('product-price');
    const compareEl = document.getElementById('product-compare-price');
    const savingsEl = document.getElementById('product-savings-pill');
    const badgeSale = document.getElementById('product-badge-sale');
    const badgeOos = document.getElementById('product-badge-oos');
    const btnAdd = document.getElementById('btn-add-to-cart');
    const btnAddText = document.getElementById('btn-add-text');
    const btnBuy = document.getElementById('btn-buy-now');

    const priceFormatted = (variant.price / 100).toLocaleString('en', { minimumFractionDigits: 2 });
    if (priceEl) priceEl.textContent = `LE ${priceFormatted}`;

    const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (onSale) {
      const compareFormatted = (variant.compare_at_price / 100).toLocaleString('en', { minimumFractionDigits: 2 });
      const savingsPct = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
      if (compareEl) {
        compareEl.textContent = `LE ${compareFormatted}`;
        compareEl.style.display = '';
      }
      if (savingsEl) {
        savingsEl.textContent = `Save ${savingsPct}%`;
        savingsEl.style.display = '';
      }
      if (badgeSale) {
        badgeSale.textContent = `${savingsPct}% OFF`;
        badgeSale.style.display = '';
      }
    } else {
      if (compareEl) compareEl.style.display = 'none';
      if (savingsEl) savingsEl.style.display = 'none';
      if (badgeSale) badgeSale.style.display = 'none';
    }

    if (variant.available) {
      if (badgeOos) badgeOos.style.display = 'none';
      if (btnAdd) {
        btnAdd.disabled = false;
        btnAdd.classList.remove('out-of-stock');
      }
      if (btnAddText) btnAddText.textContent = 'Add to Cart';
      if (btnBuy) btnBuy.style.display = '';
    } else {
      if (badgeOos) badgeOos.style.display = '';
      if (btnAdd) {
        btnAdd.disabled = true;
        btnAdd.classList.add('out-of-stock');
      }
      if (btnAddText) btnAddText.textContent = 'Sold Out';
      if (btnBuy) btnBuy.style.display = 'none';
    }

    if (variant.featured_image && variant.featured_image.src) {
      const mainImg = document.getElementById('product-main-image');
      if (mainImg) mainImg.src = variant.featured_image.src;
    }
  },

  changeQuantity(delta) {
    const input = document.getElementById('product-quantity');
    if (!input) return;
    let qty = parseInt(input.value || 1, 10) + delta;
    if (qty < 1) qty = 1;
    if (qty > 99) qty = 99;
    input.value = qty;
    this.quantity = qty;
  },

  addToCart() {
    if (!window._currentVariant || !window._currentVariant.available) return;
    const qty = parseInt(document.getElementById('product-quantity')?.value || 1, 10);
    window.ShopifyCart.add(window._currentVariant.id, qty);
  },

  async buyNow() {
    if (!window._currentVariant || !window._currentVariant.available) return;
    const qty = parseInt(document.getElementById('product-quantity')?.value || 1, 10);
    try {
      await fetch('/cart/clear.js', { method: 'POST' });
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: window._currentVariant.id, quantity: qty })
      });
      window.location.href = '/checkout';
    } catch(e) {
      window.location.href = `/cart/${window._currentVariant.id}:${qty}`;
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  window.ShopifyCart.init();
  window.ShopifyThemeProduct.init();

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animated');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('[data-animate]').forEach(el => observer.observe(el));
});
